import React, { lazy } from "react";

export const openRoutes = [
 
];
export const privateRoutes = [
  
];
